//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'NexusIIHeadCT',
  data() {
    return {
      form:{
        ageOver65:'0',
        coagulopathy:'0',
        skullFracture:'0',
        scalpHematoma:'0',

        neurologicDeficit:'0',

        abnormalBehavior:'0',
        alteredAlertness:'0',
        persistentVomiting:'0',

      },
      hasScore:false,
      disabled:false,
      defaultJson:{
        "Age ≥ 65 years": "年龄 ≥ 65 岁",
        "CT-Head indicated": "建议行头颅 CT",
        "Coagulopathy": "凝血障碍",
        "Altered Level of Alertness": "意识改变",
        "Evidence of Significant Skull Fracture": "严重的颅骨损伤证据",
        "Neurologic Deficit": "神经系统异常",
        "Scalp Hematoma": "头皮血肿",
        "Abnormal Behavior": "异常行为",
        "CT-Head not required": "无需头颅 CT",
        "Persistent Vomiting": "持续性呕吐"
      },
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
            form[key]=0
          } else { 
            form[key] = Number(form[key])
          }
        }
      }

      // skullFracture + scalpHematoma + neurologicDeficit + alteredAlertness + abnormalBehavior + coagulopathy + persistentVomiting + ageOver65

      let result = form.skullFracture + form.scalpHematoma + form.neurologicDeficit + form.alteredAlertness + form.abnormalBehavior + form.coagulopathy + form.persistentVomiting + form.ageOver65
      self.hasScore = true
      return String(result)
    },
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/NexusIIHeadCT.vue